module.exports = __webpack_public_path__ + "img/14.801f7305.jpg";